import { observer } from 'mobx-react-lite';
import { ReactElement } from 'react';

import { useUIState } from '../../../../../app/App';
import { styled } from '../../../../../styled';
import type { Theme } from '../../../../../theme/interface/detailed';

const Component = ({ className }: { className: string }): ReactElement | null => {
	const { attachmentErrorsStore } = useUIState();
	if (!attachmentErrorsStore.error) {
		return null;
	}
	return <div className={className}>{attachmentErrorsStore.error}</div>;
};

export const AttachmentError = styled(observer(Component))(
	({ theme }: { theme: Theme }) => theme.allSettings.attachments.attachmentError
);
